module.exports = __webpack_public_path__ + "images/goals/white_play.png";